import React from "react";
import type { FC, AnchorHTMLAttributes } from "react";
import { ChatMessage } from "lib/models";
import Markdown, { Components } from "react-markdown";

const CustomLink: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => {
  return (
    <a className="text-blue-700 underline hover:text-blue-900" {...props}>
      {props.children}
    </a>
  );
};

interface ChatMsgContainerProps {
  msg: ChatMessage;
}

function ChatMsgContainer({ msg }: ChatMsgContainerProps) {
  const components: Components = {
    a: CustomLink,
  };

  return msg.role === "user" ? (
    <div className="flex w-full">
      <div className="w-full flex-1"></div>
      <div className="max-w-[80%] bg-palette-4 rounded-3xl p-2 break-words">
        <Markdown components={components}>{msg.text}</Markdown>
      </div>
    </div>
  ) : (
    <div className="flex w-full">
      <div className="max-w-[80%] bg-palette-3 rounded-3xl p-2 break-words">
        <Markdown components={components}>{msg.text}</Markdown>
      </div>
      <div className="w-full flex-1"></div>
    </div>
  );
}

export default ChatMsgContainer;
